<po-page-default p-title="Arquivos RPA Disponíveis" [p-breadcrumb]="breadcrumb">
  <div class="rpa-page-actions">
    <div class="rpa-page-actions-left">
      <po-button
        p-label="Relatório"
        p-icon="an an-file-arrow-down"
        (p-click)="irRelatorio()">
      </po-button>
      <po-button
        p-label="Relatório Pendências"
        p-kind="secondary"
        p-icon="an an-file-arrow-down"
        (p-click)="abrirRelatorioPendencias()">
      </po-button>
      <po-button
        p-label="Atualizar"
        p-icon="an an-arrows-clockwise"
        (p-click)="atualizarTabela()">
      </po-button>
    </div>
    <po-button
      class="rpa-page-actions-right"
      p-label="Pendência estadual"
      p-kind="secondary"
      p-icon="an an-magnifying-glass"
      (p-click)="irAnalisePendencia()">
    </po-button>
  </div>

  <po-table
    p-container="border"
    class="rpa-table"
    p-striped="true"
    p-text-wrap="true"
    p-hide-columns-manager="true"
    [p-loading]="loadingTable"
    [p-columns]="columns"
    [p-items]="tableItems"
    [p-actions]="tableActions">
  </po-table>
</po-page-default>

<po-modal
  #modalProcessamento
  p-size="lg"
  [p-title]="processamentoSelecionado?.titulo || 'Processamento'"
  p-icon="an an-list-bullets"
  p-click-out="false"
  (p-close)="fecharModalProcessamento()">
  <div *ngIf="processamentoSelecionado" class="modal-processamento-body">
    <p class="modal-processamento-resumo">{{ processamentoSelecionado.mensagem }}</p>
    <p class="modal-processamento-resumo">
      Início: {{ processamentoSelecionado.inicio | date: 'dd/MM/yyyy HH:mm:ss' }}
    </p>

    <po-table
      p-container="border"
      class="po-lg-12 po-mt-3"
      p-striped="true"
      p-hide-columns-manager="true"
      [p-columns]="[
        { property: 'codigo', label: 'Empresa' },
        { property: 'statusLabel', label: 'Status' },
        { property: 'mensagem', label: 'Detalhe' },
        { property: 'atualizadoEm', label: 'Atualizado em', type: 'date', format: 'dd/MM/yyyy HH:mm' }
      ]"
      [p-items]="empresasModalItems">
    </po-table>
  </div>
  <po-modal-footer>
    <po-button
      *ngIf="podeCancelarProcessamentoModal"
      p-label="Cancelar processamento"
      p-kind="danger"
      p-icon="an an-x-circle"
      (p-click)="cancelarProcessamentoModal()">
    </po-button>
    <po-button
      *ngIf="podeReprocessarProcessamentoModal"
      p-label="Reprocessar"
      p-kind="secondary"
      p-icon="an an-arrows-clockwise"
      [p-loading]="reprocessandoId === processamentoSelecionado?.id"
      [p-disabled]="!!reprocessandoId"
      (p-click)="reprocessarProcessamentoModal()">
    </po-button>
    <po-button p-label="Fechar" (p-click)="fecharModalProcessamento()"></po-button>
  </po-modal-footer>
</po-modal>

<po-modal
  #modalRelatorioPendencias
  p-size="md"
  p-title="Relatório de Pendências"
  p-icon="an an-file-arrow-down"
  p-click-out="false"
  (p-close)="fecharRelatorioPendencias()">
  <div class="modal-relatorio-pendencias">
    <p class="modal-relatorio-hint">
      Lista empresas com consulta de pendência já emitida na competência. Serão gerados o CSV e o ZIP dos arquivos.
    </p>

    <po-select
      class="po-lg-12"
      p-label="Competência"
      p-placeholder="Selecione mês e ano"
      p-name="competenciaRelatorio"
      [p-show-required]="true"
      [p-required]="true"
      (p-change)="onChangeCompetenciaRelatorio($event)"
      [p-options]="competenciaRelatorioOptions"
      p-help="Ex.: 05-2026">
    </po-select>

    <po-radio-group
      class="po-lg-12 po-mt-3"
      p-label="Tipo de pendência"
      name="tipoPendenciaRelatorio"
      [ngModel]="tipoPendenciaRelatorio"
      (ngModelChange)="onChangeTipoPendenciaRelatorio($event)"
      [p-columns]="1"
      [p-options]="tipoPendenciaRelatorioOptions">
    </po-radio-group>

    <div class="modal-relatorio-tags" *ngIf="exibirFiltroTagsRelatorio && possuiFiltrosTagsRelatorio">
      <p class="modal-relatorio-tags-titulo">Filtrar por tags</p>
      <p class="modal-relatorio-tags-hint">
        Mesma regra da análise de pendência: com vários chips ativos, entram empresas cuja
        <b>todas</b> as tags estão entre as selecionadas.
      </p>
      <div class="analise-filtros-botoes">
        <button
          *ngFor="let tagFiltro of tagsRelatorioFiltro"
          type="button"
          class="filtro-chip"
          [class.filtro-ativo]="filtroTagRelatorioAtivo(tagFiltro.tag)"
          [ngStyle]="estiloChipRelatorio(tagFiltro)"
          (click)="alternarFiltroTagRelatorio(tagFiltro.tag)">
          {{ tagFiltro.label }}
        </button>
      </div>
    </div>
  </div>
  <po-modal-footer>
    <po-button p-label="Cancelar" p-kind="secondary" (p-click)="fecharRelatorioPendencias()"></po-button>
    <po-button
      p-label="Gerar relatório"
      p-icon="an an-file-arrow-down"
      [p-loading]="loadingRelatorioPendencias"
      (p-click)="gerarRelatorioPendencias()">
    </po-button>
  </po-modal-footer>
</po-modal>
